import type { Account } from "@tandemdiabetes/sugarmate-api-react-client"
import { createContext } from "react"
import type { Reading } from "src/types"

export interface RecentReadingsContextValue {
  readings: Record<Account["id"], Reading>;
  initialized: boolean;
}

const defaultValue = {
  readings: {},
  initialized: true,
}

export const RecentReadingsContext = createContext<RecentReadingsContextValue>(defaultValue)
